import React from "react";

export default function FeatureImgThree() {
  return (
    <>
      <section id="features" className="feature-section ptb-100">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-4">
              <div className="download-img">
                <img
                  src="assets/img/photo1.jpg"
                  alt="download"
                  style={{borderRadius:'20px'}}
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-7">
              <div className="feature-contents section-heading">
                

                <div className="feature-content-wrap">
                  <ul className="nav nav-tabs feature-tab" data-tabs="tabs">
                    <li className="nav-item">
                      <a
                        className="nav-link active h6"
                        href="#tab6-1"
                        data-toggle="tab"
                      >
                        <span className="ti-palette"></span>
                        Project Management
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link h6"
                        href="#tab6-2"
                        data-toggle="tab"
                      >
                        <span className="ti-vector"></span>
                        Project Proposal Development
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link h6"
                        href="#tab6-3"
                        data-toggle="tab"
                      >
                        <span className="ti-bar-chart"></span>
                        Project Evaluation
                      </a>
                    </li>
                  
                  </ul>
                  <div className="tab-content feature-tab-content">
                    <div className="tab-pane active" id="tab6-1">
                      <p >Seasoned in tackling complex challenges in project management, The Sustainable
Institute ensures continuity and quality. Our project management assumes maximum
coordination in all facets of planning and includes implementation for highly
sophisticated and specialized audiences with diverse areas of expertise. Each client
assignment is supervised by a managing partner of the firm, who works directly with
the client and manages a team of specialists to implement the program. Our strong
dedication to results constitutes our client-focused approach.</p>
                    </div>
                    <div className="tab-pane" id="tab6-2">
                    <p >Our approach to project proposal development is a carefully guided, customized
process. This rationale continues throughout the entire project cycle from research and
strategic planning to design development and implementation. We routinely prioritize
adherence to budgets and production schedules. For each client, we create a detailed
strategy developed around web meetings and thorough research. Once approved, the
plan is rapidly implemented, with measurable and tangible results. As the project
proposal development gains momentum, we frequently communicate with clients both
verbally and in bimonthly status reports. The Sustainable Institute aims to ultimately
provide clients with an opportunity to identify and access available funding
opportunities and to help ensure high quality bids and projects.</p>
                    </div>
                    <div className="tab-pane" id="tab6-3">
                    <p>The fundamental objective of an evaluation is to design and articulate the program’s
plan of action so that it can be tested at regular intervals. We believe this is key to the
decision-making and planning process. Evaluation enables continuous improvement
and learning through the implementation of recommendations and the understanding
and incorporation of lessons learned for the formulation of new strategies, programs
and projects. This allows the project to adjust and enhance the direction of its action
plan in order to maximize the quality of its delivery and increase the potential for
long-term impact. The Sustainable Institute has proven itself accomplished at
measuring performance.</p>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
